import { MTextField, ResponsiveFormContainer } from "@app/components";
import React from "react";

interface MasterTablesProps {
  atributtes: string[];
}

const MasterTablesForm = ({ atributtes }: MasterTablesProps) => {
  return (
    <ResponsiveFormContainer columns={4}>
      {atributtes.map(
        (attribute) =>
          attribute !== "id" && (
            <MTextField
              key={attribute}
              name={attribute}
              label={attribute.charAt(0).toUpperCase() + attribute.slice(1)}
              type="text"
              fullWidth
              validation={{ required: `El campo ${attribute} es requerido` }}
              disabled={attribute === "id"}
            />
          )
      )}
    </ResponsiveFormContainer>
  );
};

export default MasterTablesForm;
